'use strict';

var accentColors = require('../../../../../../../../../../_virtual/accentColors2.cjs');

var hasRequiredAccentColors;

function requireAccentColors () {
	if (hasRequiredAccentColors) return accentColors.__exports;
	hasRequiredAccentColors = 1;

	var ACCENT_COLORS = /*#__PURE__*/ function(ACCENT_COLORS) {
	    ACCENT_COLORS["accentGreen"] = "accentGreen";
	    ACCENT_COLORS["accentBlue"] = "accentBlue";
	    ACCENT_COLORS["accentOrange"] = "accentOrange";
	    ACCENT_COLORS["accentRed"] = "accentRed";
	    ACCENT_COLORS["accentPurple"] = "accentPurple";
	    return ACCENT_COLORS;
	}({});

	accentColors.__exports.ACCENT_COLORS = ACCENT_COLORS;
	
	return accentColors.__exports;
}

exports.__require = requireAccentColors;
//# sourceMappingURL=accentColors.cjs.map
